import { ThemeSpaceVariable, ToggleButton } from "@caspeco/casper-ui-library";
import { TimeSlot } from "types/time-slot";

interface ExperienceTimeSlotProps {
    time: TimeSlot;
    selectedTime?: TimeSlot;
    onClick: () => void;
    trackingId?: string;
}

export default function ExperienceTimeSlot({
    time,
    selectedTime,
    onClick,
    trackingId,
}: ExperienceTimeSlotProps) {
    const isSelected = selectedTime?.start.isSame(time.start) ?? false;

    return (
        <ToggleButton
            key={time.start.format("HH:mm")}
            onClick={onClick}
            isPressed={isSelected}
            w="full"
            px={ThemeSpaceVariable.Small}
            size="lg"
            data-track-click={trackingId}
        >
            {time.start.format("HH:mm")}
        </ToggleButton>
    );
}
